export class SsoFlowState {
  constructor(
    readonly id: string,
    readonly redirectUri: string,
    readonly route: string,
  ) {}
}
